import { TipsMapType } from '@op/components/BubbleCommon';
import React from 'react';

export const adCreativesHeaderTipsMap: TipsMapType = {
  en: (
    <>
      Mahjong and Arrows-like creatives data: Updated daily. <br />
      Other game creatives data: Updated weekly.
    </>
  ),
  zh: (
    <>
      麻将与箭头类素材数据每日更新。 <br />
      其他游戏素材数据当前为每周更新。
    </>
  ),
};

export const adCreativesStopTipsMap: TipsMapType = {
  zh: (
    <>7月8日之后的素材数据暂停采集中，我们正在准备新方案，恢复会第一时间同步。</>
  ),
  en: (
    <>
      Data collection for ad creatives from July 8 onwards is currently paused.
      We are preparing a new plan and will provide an update as soon as service
      resumes.
    </>
  ),
};

export const adCreativesDeduplicationTipsMap: TipsMapType = {
  en: 'Only ad-level statistics are supported currently; creative-level deduplication is not implemented.',
  zh: '当前仅支持广告粒度统计，未进行素材粒度的去重。',
};
